import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

import {TopBarBlock} from '../common/MainBlocks';
import TabLinkGroup from '../common/TabLinkGroup';
import TabLink from '../common/TabLink';

const Topbar = ({role}) => {
  const {t} = useTranslation();

  return (
    <TopBarBlock fixed white>
      <LeftSide>
        <TabLinkGroup>
          <TabLink to="/settings/profile">
            {t('profile')}
          </TabLink>
          {role === 'administrator' && (
            <TabLink to="/settings/administration">
              Администрирование
            </TabLink>
          )}
        </TabLinkGroup>
      </LeftSide>
    </TopBarBlock>
  );
};

const LeftSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

Topbar.propTypes = {
  role: PropTypes.string,
};

Topbar.defaultProps = {
  role: '',
};

const mapStateToProps = ({manager}) => ({
  role: manager.data?.role,
});

export default connect(mapStateToProps)(Topbar);
